<template>
  <div id="app">
    <navbar></navbar>
    <div class="gap"></div>
    <div class="container">
      <transition name="slide-fade">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'

export default {
  name: 'app',
  components: {
    Navbar
  }
}
</script>

<style>
.gap {
  margin-top: 0px;
}

.modal-body{
  max-height: 60vh !important;
  overflow-y: scroll !important;
}
.link {
  cursor: pointer;
  color: blue;
}
.container{
  padding-bottom: 100px
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  /* */
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?00385bba